import { Capacitor } from "@capacitor/core";

/**
 * Returns true when the app is running inside a native Capacitor shell.
 * Use this everywhere instead of calling Capacitor.isNativePlatform() directly.
 */
export function useIsNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** Non-hook version for use outside React components */
export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

/** Standard bottom padding class to clear the docked tab bar */
export const NATIVE_BOTTOM_PAD = "native-dock-pad";
